<template>
    <div class="listOne" v-show="newList.length > 0">
        <ul class="m-list7">
            <li v-for="(item, index) in newList" :key="index" class="box-list clearfix"
                @click="shoDetial(item.article_id)">
                <div class="con">
                    <span class="date">{{ item.publish_time ? item.publish_time.substring(0, 10) : "--" }}</span>
                    <h3 class="tit">{{ item.article_title }}</h3>
                </div>
            </li>
            <div class="page">
                <el-pagination @current-change="handleCurrentChange" :current-page.sync="currentPage"
                    :page-size="pageSize" layout="prev, pager, next, jumper" :total="total">
                </el-pagination>
            </div>
        </ul>
    </div>
</template>
<script>
export default {
    props: {
        // article_title: {
        //     type: String,
        //     default: '',

        // }
    },
    data() {
        return {
            newList: [],
            total: 0,
            currentPage: 1,
            pageSize: 10,
            article_title: ""
        }
    },
    mounted() {
        // this.getList()
    },
    methods: {
        getList(article_title) {
            console.log(article_title)
            this.article_title = article_title
            let self = this
            this.newList = []
            this.$common.noLoginCallUrl('/api/cp-cms/site/info/getInfoPage', {
                pageNo: self.currentPage,
                pageCount: self.pageSize,
                article_title: article_title
            },
                function (res) {
                    if (res.code == '000000') {
                        self.newList = res.data.data || []
                        self.total = res.data.count
                    } else {
                        self.$message.warning(res.msg)
                    }
                })
        },
        search() {
            this.getList(this.article_title)
        },
        handleSizeChange() {

        },
        handleCurrentChange(item) {
            this.currentPage = item
            this.getList(this.article_title)
        },
        shoDetial(item) {
            this.$emit('detail', item)
        }
    },
    watch: { // 监听，当路由发生变化的时候执行

    }
};
</script>

<style lang="less" scoped>


.m-list7 .con {
  box-sizing: border-box;
  display: block;
  overflow: hidden;
  line-height: 74px;
  border-bottom: 1px dotted rgba(2, 17, 52, .35);
}

.m-list7 ul,
h3 {
  margin: 0;
  padding: 0;
}

.m-list7 li {
  list-style: none;
}

.m-list7 .date {
  float: right;
  margin-left: 30px;
  font-size: 18px;
  color: #666;
}

.m-list7 .tit {
  box-sizing: border-box;
  font-size: 20px;
  font-weight: normal;
  color: #000;
  position: relative;
  padding-left: 28px;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
  transition: .3s;
  -ms-transition: .3s;
  -moz-transition: .3s;
  -webkit-transition: .3s;
  -o-transition: .3s;
}

.m-list7 .tit:after {
  content: '';
  position: absolute;
  left: 14px;
  top: 50%;
  width: 5px;
  height: 5px;
  border-radius: 50%;
  background-color: #000;
  -webkit-transform: translateY(-50%);
  -moz-transform: translateY(-50%);
  -o-transform: translateY(-50%);
  -ms-transform: translateY(-50%);
  transform: translateY(-50%);
  transition: .3s;
  -ms-transition: .3s;
  -moz-transition: .3s;
  -webkit-transition: .3s;
  -o-transition: .3s;
}

.m-list7 .con:hover .tit {
  color: #2F60AD;
}

.m-list7 .con:hover .tit:after {
  background-color: #2F60AD;
}
.page {
  text-align: center;
  margin: 90px 0 20px;
}

@media screen and (max-width: 1025px) {
  .m-list7 {
    margin: 0;
    padding: 0;

    .con {
      height: 4em;
      line-height: 4em;
      .date{
        font-size: 13px;
        margin-left: 15px;
      }
      .tit{
        font-size: 16px;
        padding-left: 18px;
        &:after{
          width: 4px;
        height: 4px;
        left: 3px;
        }
      }
    }
  }

  .el-pagination {
    white-space: wrap;
    padding: 0;
    /deep/ .number,
    /deep/ .btn-prev,
    /deep/ .btn-next {
      padding: 0 5px !important;
      min-width: 20px !important;
    }
    /deep/ .el-pagination__jump{
      margin-left: 5px !important;
    }
  }
}


</style>